export const Size = "VEC_BGR_093";
export const GuidewayDesign = "VEC_MKB_093";

export const Coating = "VEC_BSCH_093";
export const Accuracy = "VEC_GEN_093";

export const DesignType_Series = "VB_MKB_093";
export const DesignType_SizeCode = "VB_BGR_093";
export const DesignType_Version = "VB_VER_093";

export const MountingHoleType = "VEC_SBF_093";
export const ClosingPlugs = "VEC_SKA_093";

export const CoveringStrip = "VEC_SAF_093";
export const CounterboreChamfered = "VEC_SSBG_093";

export const LocatingFace = "VEC_ANS_093";
export const GuidewayLength = "VEC_KWL_093";
export const GuidewayLengthMin = "VEC_LMIN_093";
export const GuidewaySinglePieceLengthMax = "VEC_LMAX_093";
export const GuidewayLengthMax = "VEC_LAMAX_093";

export const AL = "VEC_AAL_093";
export const ALMin = "VEC_ALMIN_093";
export const ALMax = "VEC_ALMAX_093";
export const AR = "VEC_AAR_093";
export const FixedHoleDistance = "VJL_091";

export const PartSizing = "VEC_VST_093";
export const PartAmount = "VEC_TLA_093";
